const INDENT = '  ';

interface EditResult {
  value: string;
  cursor: number;
}

export function insertIndent(value: string, start: number, end: number): EditResult {
  return {
    value: `${value.slice(0, start)}${INDENT}${value.slice(end)}`,
    cursor: start + INDENT.length,
  };
}

export function insertSmartNewLine(value: string, start: number, end: number): EditResult {
  const lineStart = value.lastIndexOf('\n', start - 1) + 1;
  const lineBeforeCursor = value.slice(lineStart, start);
  const baseIndent = lineBeforeCursor.match(/^[\t ]*/)?.[0] ?? '';
  const trimmedBeforeCursor = lineBeforeCursor.trimEnd();
  const afterCursor = value.slice(end);
  const nextNonSpace = afterCursor.match(/^\s*([}\])])/)?.[1];
  const shouldIndent = /(?:\{|\[|\(|=>)$/.test(trimmedBeforeCursor);
  const nextIndent = `${baseIndent}${shouldIndent ? INDENT : ''}`;

  if (shouldIndent && nextNonSpace) {
    const insert = `\n${nextIndent}\n${baseIndent}`;
    return {
      value: `${value.slice(0, start)}${insert}${afterCursor}`,
      cursor: start + 1 + nextIndent.length,
    };
  }

  const insert = `\n${nextIndent}`;
  return {
    value: `${value.slice(0, start)}${insert}${afterCursor}`,
    cursor: start + insert.length,
  };
}
